import type { SVGProps } from "react";
export interface WrenchScrewdiverIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function WrenchScrewdiverIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: WrenchScrewdiverIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M12.191 2.467a6.63 6.63 0 0 1 6.825-1.097 1.125 1.125 0 0 1 .37 1.836L16.22 6.37l.235 1.173 1.173.236 3.165-3.164.104-.092a1.126 1.126 0 0 1 1.732.461 6.63 6.63 0 0 1-1.446 7.201 6.62 6.62 0 0 1-6.47 1.69l-8.296 8.297a3.247 3.247 0 0 1-4.344.223l-.246-.223a3.246 3.246 0 0 1 0-4.59l8.295-8.297a6.62 6.62 0 0 1 1.692-6.469l.376-.349Zm4.086.664a4.377 4.377 0 0 0-3.825 6.032c.172.42.075.901-.246 1.222l-8.788 8.787a.997.997 0 0 0 0 1.41l.157.127a1 1 0 0 0 1.253-.127l8.787-8.788.128-.11a1.13 1.13 0 0 1 1.095-.136 4.376 4.376 0 0 0 6.03-3.826l-2.072 2.074a1.13 1.13 0 0 1-1.016.308l-2.5-.501a1.12 1.12 0 0 1-.883-.882l-.5-2.5c-.074-.37.042-.75.307-1.016z"
      />
      <path
        fill={color}
        d="M18.705 15.705a1.124 1.124 0 0 1 1.504-.078l.087.078 1.969 1.969a3.125 3.125 0 0 1 0 4.42l-.172.17a3.125 3.125 0 0 1-4.42 0l-3.636-3.636-.077-.085a1.125 1.125 0 0 1 1.582-1.582l.085.076 3.638 3.637a.876.876 0 0 0 1.237 0l.172-.171a.876.876 0 0 0 0-1.238l-1.969-1.97-.078-.086a1.124 1.124 0 0 1 .078-1.504M2.324 1.101c.292-.22.679-.287 1.032-.169l3 1c.46.154.77.585.77 1.069v2.534l.69.69.076.085A1.125 1.125 0 0 1 6.31 7.892l-.085-.077-.69-.69H3c-.484 0-.914-.31-1.067-.769l-1-3a1.13 1.13 0 0 1 .272-1.15l1-1.001zm.962 2.203.525 1.572h1.064V3.81l-1.571-.525z"
      />
    </svg>
  );
}
